import { IFinanceExpensesState } from '@adex/shared/models/states/finance.state'
import { createReducer, on } from '@ngrx/store'
import { unauthorizedUser } from '@adex/store/actions'
import { getInitPagination } from '@adex/shared/models/pagination'
import { patchState } from '@adex/store/utils'
import { setFinanceExpensesData, setFinanceExpensesHasMorePage, setFinanceExpensesPageIndex } from '@adex/store/actions/finance.actions'


const initialState: IFinanceExpensesState = {
  pagination: getInitPagination(),
  data: []
}

export const financeExpensesReducer = createReducer(
  initialState,
  on(unauthorizedUser, () => ({ ...initialState })),
  on(setFinanceExpensesHasMorePage, ((state, { hasMore }) => patchState(state, 'pagination', { hasMore }))),
  on(setFinanceExpensesPageIndex, ((state, { page }) => patchState(state, 'pagination', { page }))),
  on(setFinanceExpensesData, (state, { data }) => ({ ...state, data }))
)
